import { notificationsApi } from "@api/notifications";
import { withCancel } from "@api/utils";
import { Truncate } from "@components/Truncate";
import LiteratureTitle from "@modules/Literature/LiteratureTitle";
import { BackOfficeRoutes } from "@routes/urls";
import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Icon, Modal, Popup } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default class OverdueLoanSendNotificationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reminders: {},
      isModalOpen: false,
    };
  }

  componentDidMount() {
    const { loan } = this.props;
    this.fetchOverdueLoansNotificationReminders(loan.metadata.pid);
  }

  componentWillUnmount() {
    // Cancel any pending API requests
    if (this.cancellableFetchReminders) {
      this.cancellableFetchReminders.cancel();
      this.cancellableFetchReminders = null;
    }
  }

  fetchOverdueLoansNotificationReminders = async (loanPid) => {
    this.cancellableFetchReminders = withCancel(
      notificationsApi.list(
        notificationsApi
          .query()
          .withNotificationAction("overdue_reminder")
          .withPidType("loanid")
          .withPidValue(loanPid)
          .qs()
      )
    );
    const response = await this.cancellableFetchReminders.promise;
    this.setState({ reminders: response.data });
  };

  toggle = () => {
    const { isModalOpen } = this.state;
    this.setState({ isModalOpen: !isModalOpen });
  };

  sendNotification = async () => {
    const { loan, sendOverdueLoansNotificationReminder } = this.props;
    this.toggle(); // Close modal

    try {
      await sendOverdueLoansNotificationReminder({
        loanPid: loan.metadata.pid,
      });

      toast.success("📬 Reminder email sent successfully!");
    } catch (error) {
      toast.error("❌ Failed to send reminder email.");
    }
  };

  renderTrigger = () => {
    const { isLoading } = this.props;
    const remindersCount = this.state.reminders.length;

    return (
      <div style={{ display: "flex", width: "100%" }}>
        <Popup
          content="Send return reminder"
          trigger={
            <Button
              fluid
              color="orange"
              onClick={this.toggle}
              loading={isLoading}
              disabled={isLoading}
              style={{
                flexGrow: 1,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                margin: 0,
                borderRight: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                name="mail"
                style={{
                  marginRight: "0.5em",
                  verticalAlign: "middle",
                }}
              />
              <Truncate lines={1} width="auto">
                Send return reminder
              </Truncate>
            </Button>
          }
        />
        <div
          style={{
            backgroundColor: "white",
            border: "1px solid rgba(34,36,38,.15)",
            borderTopRightRadius: "0.28571429rem",
            borderBottomRightRadius: "0.28571429rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "50px",
            padding: "0.78571429em 0.833em",
            color: "rgba(0,0,0,.87)",
            fontSize: "1em",
          }}
        >
          <span style={{ marginRight: "6px", fontWeight: "bold" }}>
            {remindersCount}
          </span>
          <Popup
            trigger={
              <Icon
                name="question circle"
                style={{
                  cursor: "pointer",
                  opacity: 0.7,
                  marginBottom: "7px",
                }}
              />
            }
            content="Number of reminders sent might be inaccurate in case of queued notifications not sent yet."
            position="top left"
            size="small"
          />
        </div>
      </div>
    );
  };

  render() {
    const { loan } = this.props;
    const { isModalOpen } = this.state;
    if (!loan.metadata.is_overdue || _isEmpty(loan.metadata.item)) return null;
    return (
      <Modal trigger={this.renderTrigger()} open={isModalOpen}>
        <Modal.Header>E-mail reminder</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <p>
              Overdue loan for the literature:
              <strong>
                <Link
                  to={BackOfficeRoutes.documentDetailsFor(
                    loan.metadata.document.pid
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LiteratureTitle
                    title={loan.metadata.document.title}
                    edition={loan.metadata.document.edition}
                    publicationYear={loan.metadata.document.publication_year}
                  />
                </Link>
              </strong>
            </p>
            <p>
              {"Do you want to send a reminder e-mail to "}
              <strong>
                <Link
                  to={BackOfficeRoutes.patronDetailsFor(
                    loan.metadata.patron_pid
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {loan.metadata.patron.name}
                </Link>
              </strong>
              ?
            </p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={this.toggle}>
            <Icon name="cancel" /> Cancel
          </Button>
          <Button color="green" onClick={this.sendNotification}>
            <Icon name="send" /> Send
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

OverdueLoanSendNotificationModal.propTypes = {
  loan: PropTypes.object.isRequired,
  sendOverdueLoansNotificationReminder: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

OverdueLoanSendNotificationModal.defaultProps = {
  isLoading: false,
};
